import { service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import config from 'frontend/config/environment';

interface Partners {
  href: string;
  src: string;
  alt: string;
}

export default class FooterPartnersComponent extends Component {
  @service declare intl: IntlService;

  get wpUrl() {
    return config.wpUrl;
  }

  get partners(): Partners[] {
    return [
      {
        href: 'https://www.digitalwallonia.be/fr/',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/digital_wallonia.png`,
        alt: this.intl.t('components.footer.partners.alt_dw'),
      },
      {
        href: 'https://www.leforem.be/centres-de-competence.html',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/CDC-logo.png`,
        alt: this.intl.t('components.footer.partners.alt_rcdc'),
      },
      {
        href: 'https://edu-lab.be/',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/edulab-log.png`,
        alt: this.intl.t('components.footer.partners.alt_edulab'),
      },
      {
        href: 'https://www.interreg-fwvl.eu/fr',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/interreg-logo.png`,
        alt: this.intl.t('components.footer.partners.alt_interreg'),
      },
      {
        href: 'https://numeria-academy.be/',
        src: `${this.wpUrl}/wp-content/uploads/2023/04/numeria_academy.png`,
        alt: this.intl.t('components.footer.partners.alt_numeria'),
      },
    ];
  }
}
